import { Timestamp } from "firebase/firestore";
import { format } from "date-fns";
import { TFunction } from "i18next";

export function formatFirestoreTimestamp(
  timestamp?: Timestamp | Date | string | null,
): string {
  if (!timestamp) {
    return " ";
  }

  let date: Date | null = null;

  if (timestamp instanceof Date) {
    date = timestamp;
  } else if (typeof timestamp === "string") {
    date = new Date(timestamp);
  } else if (
    typeof timestamp === "object" &&
    "toDate" in timestamp &&
    typeof timestamp.toDate === "function"
  ) {
    date = timestamp.toDate();
  }

  if (!date || Number.isNaN(date.getTime())) {
    return " ";
  }

  const day = `0${date.getDate()}`.slice(-2);
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export function formatDateTime(date: Date): string {
  return format(date, "MMM d, yyyy, HH:mm");
}

// ToDo: IProduct has a type issue with dates and nested dates
export const convertToDateStr = (
  t: TFunction,
  dateInput?: Date | Timestamp | null,
): string => {
  if (!dateInput) {
    return t("general:unknownDate");
  }
  if (
    typeof dateInput === "object" &&
    "toDate" in dateInput &&
    typeof dateInput.toDate === "function"
  ) {
    return formatDateTime(dateInput.toDate());
  }
  return formatDateTime(dateInput as Date);
};
